import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FattyPattyMobileActions from './FattyPattyMobileActions';
import FattyCartDrawer from '../../../../../apps/table-tuck-web/src/app/components/fattyCartDrawer';
import CartDrawer from '../../../../../apps/table-tuck-web/src/app/components/CartDrawer/CartDrawer';
import { environment } from '../../../../../apps/table-tuck-web/src/environments/environment';

export function FattyPattyLoggedInUser({
  counter,
  openCartDialoge,
  onHoverCart,
  onHoverLeaveCart,
  handleCloseCartDialoge,
  userData,
  anchorElProfile,
  handleOpenProfileMenu,
  handleCloseProfileMenu,
  signOut,
  navigate,
  addresses,
  defaultStoreAdress,
  setDefaultStoreAdress,
  isCheckoutPage = false,
  isIOS = false,
}) {
  const isFattyPatty =
    environment?.restaurantId === 'fattyPattyDev' ||
    environment?.restaurantId === 'fattyPatty';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
      }}
    >
      {/* Cart Icon - hover opens drawer, click navigates to cart page */}
      {!isCheckoutPage && (
        <>
          <div
            style={{
              border: '1px solid #FFFFFF66',
              background: 'transparent',
              borderRadius: '50%',
              width: '45px',
              height: '45px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              position: 'relative',
            }}
            onClick={() => navigate('/cart')}
            onMouseEnter={onHoverCart}
            onMouseLeave={onHoverLeaveCart}
          >
            <ShoppingCartIcon
              style={{
                color: 'white',
                fontSize: '20px',
              }}
            />
            {counter > 0 && (
              <div
                style={{
                  position: 'absolute',
                  top: '-5px',
                  right: '-5px',
                  backgroundColor: '#FF6B6B',
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  color: 'white',
                  fontWeight: 'bold',
                }}
              >
                {counter}
              </div>
            )}
          </div>
          {openCartDialoge &&
            !isIOS &&
            (isFattyPatty ? (
              <FattyCartDrawer
                openCartDialoge={openCartDialoge}
                handleCloseCartDialoge={handleCloseCartDialoge}
                userData={userData}
              />
            ) : (
              <CartDrawer
                openCartDialoge={openCartDialoge}
                handleCloseCartDialoge={handleCloseCartDialoge}
                addresses={addresses}
                userData={userData}
                defaultStoreAdress={defaultStoreAdress}
                setDefaultStoreAdress={setDefaultStoreAdress}
              />
            ))}
        </>
      )}

      {/* FattyPatty specific actions - only for fattyPatty logged in users */}
      {isFattyPatty && (
        <FattyPattyMobileActions
          userData={userData}
          anchorElProfile={anchorElProfile}
          handleOpenProfileMenu={handleOpenProfileMenu}
          handleCloseProfileMenu={handleCloseProfileMenu}
          signOut={signOut}
          navigate={navigate}
        />
      )}
    </div>
  );
}

export default FattyPattyLoggedInUser;
